import { UserType } from './actions';

export const STORE_USER = "STORE_USER";
export const StoreUserAction = {
    type: STORE_USER,
    payload: UserType
}

